import { render } from "./Venue2023.vue?vue&type=template&id=e7683c48"
import script from "./Venue2023.js?vue&type=script&lang=js"
export * from "./Venue2023.js?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__